import React, { useState } from "react";
import swal from "sweetalert";

import { useForm } from "react-hook-form";
import ClassroomForm from "../../components/ClassRooms/ClassroomForm";
import Container from "../../components/Container/Container";
import { API } from "../../constants/env";
import { useParams } from "react-router-dom";

function EditSalle() {
  let { id } = useParams();

  const { register, handleSubmit, errors, reset } = useForm();
  const [data, setData] = useState({});
  React.useEffect(() => {
    const fetchdata = async () => {
      fetch(API.salle.info(id), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((res) => res.json())
        .then((response) => {
          if (response.error) {
            return swal("Error", response.message, "error");
          }

          setData(response);
        })
        .catch((e) => {});
    };
    fetchdata();
  }, [id]);
  const onSubmit = (data) => {
    fetch(API.salle.update(id), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": localStorage.getItem("token"),
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((response) => {
        if (response.error) {
          return swal("Error", response.message, "error");
        }
        return swal("Good job!", "salle modifie", "success");
      })
      .catch((e) => {});
  };
  return (
    <Container
      name="Modifier une salle "
      back={true}
      backRoute="/salles"
      submit={true}
    >
      <ClassroomForm
        register={register({ required: true })}
        errors={errors}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        reset={reset}
        data={data}
      />
    </Container>
  );
}

export default EditSalle;
